export const LOADING_STATUSES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
};

export const BILLING_STATUSES = {
  0: 'None',
  1: 'OK',
  2: 'Payment required',
  3: 'Payment failed',
};

export const BILLING_STATUSES_LIST = [
  {
    value: 0,
    label: 'None',
  },
  {
    value: 1,
    label: 'OK',
  },
  {
    value: 2,
    label: 'Payment required',
  },
  {
    value: 3,
    label: 'Payment failed',
  },
];

export const BILLING_STATUSES_COLORS = {
  1: 'success',
  2: 'warning',
  3: 'error',
};

export const VIEWS_STATUSES = {
  '': 'None',
  0: 'Unverified',
  1: 'Active',
  2: 'Banned',
  3: 'Fraud',
};

export const VIEWS_STATUSES_LIST = [
  {
    value: '',
    label: 'None',
  },
  {
    value: 0,
    label: 'Unverified',
  },
  {
    value: 1,
    label: 'Active',
  },
  {
    value: 2,
    label: 'Banned',
  },
  {
    value: 3,
    label: 'Fraud',
  },
];

export const VIEWS_STATUSES_COLORS = {
  1: 'success',
  2: 'error',
  3: 'warning',
};

export const TRANSACTIONS_STATUSES_COLORS = {
  approved: 'success',
  approved_cr: 'warning',
  failed: 'error',
  cancelled: '',
};

export const TRANSACTIONS_STATUS_NONE = {
  value: '',
  label: 'None',
};

export const TRANSACTIONS_STATUS_APPROVED = {
  value: 'approved',
  label: 'Approved',
};

export const TRANSACTIONS_STATUS_APPROVED_CR = {
  value: 'approved_cr',
  label: 'Approved (CR)',
};

export const TRANSACTIONS_STATUS_FAILED = {
  value: 'failed',
  label: 'Failed',
};

export const TRANSACTIONS_STATUS_CANCELLED = {
  value: 'cancelled',
  label: 'Cancelled',
};

export const TRANSACTIONS_STATUS_PENDING = {
  value: 'pending',
  label: 'Pending',
};

/**
 * service status for cell state management
 */
export const TRANSACTIONS_STATUS_FETCHING = {
  value: '_fetching',
  label: '',
};

export const TRANSACTIONS_STATUS_LIST = [
  TRANSACTIONS_STATUS_NONE,
  TRANSACTIONS_STATUS_APPROVED,
  TRANSACTIONS_STATUS_APPROVED_CR,
  TRANSACTIONS_STATUS_FAILED,
  TRANSACTIONS_STATUS_CANCELLED,
  TRANSACTIONS_STATUS_PENDING,
];

export const PROMO_CODES_STATUSES = {
  0: 'Deactiveted',
  1: 'Active',
};

export const PROMO_CODES_STATUS_LIST = [
  {
    value: 0,
    label: 'Deactiveted',
  },
  {
    value: 1,
    label: 'Active',
  },
];
